import { Component, Input, OnDestroy, OnInit } from '@angular/core';

@Component({
  selector: 'badges-count',
  templateUrl: 'badges-count.component.html',
  styleUrls: ['badges-count.component.scss'],
})
export class BadgesCountComponent implements OnInit, OnDestroy {

  @Input() validJobTitles = [];
  @Input() validSkills = [];
  
  constructor() {
  }

  ngOnInit(): void {
    console.log("job",this.validJobTitles)
    console.log("skill",this.validSkills)
  }

  ngOnDestroy(): void {
  }

  openReport(url: string) {
  if (url) {
    window.open(url, '_blank');
  }
}
}
